import {
  ADVANCE_COMPANY_SEARCH_HOW_IT_WORKS_VIDEO_URL,
  ADVANCE_PEOPLE_SEARCH_HOW_IT_WORKS_VIDEO_URL,
  AI_CONTACT_PROFILE_ANALYTICS_HOW_IT_WORKS_VIDEO_URL,
  COMPANY_LOOKALIKE_SEARCH_HOW_IT_WORKS_VIDEO_URL,
  ENRICHMENT_HOW_IT_WORKS_VIDEO_URL,
} from '@aibees/elephant/constants';
import { FeatureFlags } from '@aibees/elephant/types';
import { HomeAnalysisSearch } from '../home-analysis-search';
import { HomeCompanySearch } from '../home-company-search';
import { HomePeopleSearch } from '../home-people-search';
import { SemanticSearch } from '../semantic-search';
import { ServiceType } from '../service-card/types';
import { ServiceItem } from './types';

export const serviceCards: ServiceItem[] = [
  {
    actionType: 'DIALOG',
    icon: 'fingerPrint',
    popoverTitle: 'AI Lookalike Company Search',
    service: 'AI Company Search',
    status: 'Popular' as const,
    title: 'Company Lookalike Search',
    searchCategory: 'company',
    serviceType: ServiceType.Similarity,
    description:
      'Discover similar companies to find new clients or competitors.',
    onStart: (event: any) => {
      event.preventDefault();
    },
    howItWorksVideoUrl: COMPANY_LOOKALIKE_SEARCH_HOW_IT_WORKS_VIDEO_URL,
    onProductTour: () => {},
    searchComponent: <HomeCompanySearch />,
  },
  {
    actionType: 'DIALOG',
    searchComponent: <HomePeopleSearch />,
    icon: 'fingerPrint',
    popoverTitle: 'AI Lookalike People Search',
    service: 'AI People Search',
    status: 'Popular' as const,
    feature: FeatureFlags.PEOPLE_LOOKALIKE_SEARCH,
    title: 'People Lookalike Search',
    searchCategory: 'people',
    serviceType: ServiceType.Similarity,
    description:
      'Instantly spot lookalike prospects for hiring, ads, or outreach.',
    onStart: (event: any) => {
      event.preventDefault();
    },
    onProductTour: () => {},
  },
  {
    actionType: 'ROUTE',
    route: 'searchCompany',
    icon: 'business',
    popoverTitle: '',
    service: 'Company Search',
    status: 'Popular' as const,
    title: 'Advance Company Search',
    searchCategory: 'company',
    description:
      'Refine targets by firmographics, filters, technology, and funding data.',
    onStart: () => {
      window.open('/search/company', '_blank');
    },
    howItWorksVideoUrl: ADVANCE_COMPANY_SEARCH_HOW_IT_WORKS_VIDEO_URL,
    onProductTour: () => {},
  },
  {
    actionType: 'ROUTE',
    route: 'searchPeople',
    icon: 'people',
    popoverTitle: '',
    service: 'People Search',
    status: 'Popular' as const,
    title: 'Advance People Search',
    searchCategory: 'people',
    description: 'Locate prospects by filters and export 99% verified emails.',
    onStart: () => {
      window.open('/search/people', '_blank');
    },
    howItWorksVideoUrl: ADVANCE_PEOPLE_SEARCH_HOW_IT_WORKS_VIDEO_URL,
    onProductTour: () => {},
  },
  {
    actionType: 'ROUTE',
    route: 'enrichPage',
    icon: 'view-in-ar',
    popoverTitle: '',
    service: 'Enrichment',
    status: 'Popular' as const,
    feature: FeatureFlags.ENRICHMENT,
    title: 'Enrich Data',
    description: 'Verify and enhance data with a quick CSV upload.',
    onStart: () => {
      window.open('/enrich', '_blank');
    },
    howItWorksVideoUrl: ENRICHMENT_HOW_IT_WORKS_VIDEO_URL,
    onProductTour: () => {},
  },
  {
    actionType: 'DIALOG',
    searchComponent: <HomeAnalysisSearch />,
    icon: 'filter-star',
    popoverTitle: 'Contact Profile Analysis',
    service: 'AI Analysis',
    status: 'Popular' as const,
    title: 'AI Contact Profile Analytics',
    searchCategory: 'people',
    serviceType: ServiceType.Analysis,
    description:
      'Analyze LinkedIn profiles with AI for stronger sales calls and emails.',
    onStart: (event: any) => {
      event.preventDefault();
    },
    howItWorksVideoUrl: AI_CONTACT_PROFILE_ANALYTICS_HOW_IT_WORKS_VIDEO_URL,
    onProductTour: () => {},
  },
  {
    actionType: 'ROUTE',
    route: 'apiManagementDashboard',
    icon: 'module-puzzle',
    popoverTitle: '',
    service: 'Integrate',
    status: 'Popular' as const,
    title: 'Developer API',
    description:
      'Connect your stack in minutes. Pull campaign data, sync leads, and automate workflows across your B2B marketing tools.',
    onStart: () => {
      window.open('/settings/api-management/dashboard', '_blank');
    },
    onProductTour: () => {},
  },
  {
    actionType: 'ROUTE',
    route: 'searchPeople',
    search: '?current_job_include_job_title=founder+%26+ceo&view=chart',
    icon: 'chart-line',
    popoverTitle: '',
    service: 'Visualize',
    status: 'Popular' as const,
    title: 'Data Visualization',
    description: 'Turn any search into charts, maps, and breakdowns.',
    onStart: () => {
      window.open(
        '/search/people?current_job_include_job_title=founder+%26+ceo&view=chart',
        '_blank'
      );
    },
    onProductTour: () => {},
  },
  {
    actionType: 'DIALOG',
    searchComponent: <SemanticSearch />,
    icon: 'feather',
    status: 'Soon!' as const,
    popoverTitle: 'AI Semantic Search',
    service: 'AI Semantic Company Search',
    feature: FeatureFlags.COMPANY_SEMANTIC_SEARCH,
    title: 'AI Semantic Company Search',
    searchCategory: 'company',
    serviceType: ServiceType.Semantic,
    description: 'Use AI to find companies that match your exact criteria.',
    onStart: (event: any) => {
      event.preventDefault();
    },
    onProductTour: () => {},
  },
  {
    actionType: 'ROUTE',
    icon: 'people-group',
    popoverTitle: '',
    service: 'AI Buying Team',
    status: 'Soon!' as const,
    feature: FeatureFlags.BUYING_TEAM,
    title: 'Buying Committee Search',
    searchCategory: 'people',
    description: 'Build and manage your buying teams in minutes.',
    onStart: () => {
      window.open('/search/people', '_blank');
    },
    onProductTour: () => {},
  },
  {
    actionType: 'ROUTE',
    icon: 'signals',
    service: 'Signals',
    status: 'Soon!' as const,
    feature: FeatureFlags.ALERTS,
    title: 'Set up Alerts and Triggers',
    description:
      'Get real‐time signals like funding or growth for timely opportunities.',
    onStart: (event: any) => {},
    onProductTour: () => {},
  },
];
